import { useNavigate } from 'react-router'
import { FaArrowLeft } from 'react-icons/fa'

import Filler from '../utils/Filler'

const NotFound: React.FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <div className="relative flex w-full justify-center">
        <div className="h-dvh" />
        <div className="border-theme relative flex w-full max-w-[600px] flex-col border-r border-b border-l md:mr-0">
          <div className="flex w-full">
            <div className="flex h-[60px] w-full items-center pl-[10px] text-xl font-bold">
              <button
                onClick={() => {
                  navigate('/home', {
                    replace: true,
                  })
                }}
                className="hover-main flex h-[40px] w-[40px] items-center justify-center rounded-full text-sm"
              >
                <FaArrowLeft />
              </button>
              <p className="pl-[20px] tracking-wide">Not Found</p>
            </div>
          </div>
          <Filler />
          <div className="w-full">this page does not exist</div>
        </div>
      </div>
    </>
  )
}

export default NotFound
